import { render, staticRenderFns } from "./ParkingCommon.vue?vue&type=template&id=228ddafe&scoped=true"
import script from "./ParkingCommon.vue?vue&type=script&lang=js"
export * from "./ParkingCommon.vue?vue&type=script&lang=js"
import style0 from "./ParkingCommon.vue?vue&type=style&index=0&id=228ddafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ddafe",
  null
  
)

export default component.exports